<template>
  <b-steps
    v-model="step"
    :has-navigation="false"
    :clickable="false"
    size="is-medium"
    mobile-mode="compact"
  >
    <template
      v-for="index in totalSteps"
    >
      <b-step-item
        :key="index"
        :step="index-1"
        :clickable="false"
        :icon="completedStep(index-1)"
      />
    </template>
  </b-steps>
</template>
<script>
export default {
  data() {
    return {
      icons: {
        0: 'account',
        1: 'bank',
        2: 'nut',
      },
    };
  },
  props: {
    totalSteps: {
      type: Number,
      required: true,
    },
    step: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    completedStep(index) {
      return this.step > index ? 'check' : this.icons[index];
    },
  },
};
</script>
